import { useLayoutEffect } from "react";

// Publishes an element's rendered height as a CSS custom property on <html>
// (e.g. `--search-filter-bar-height: 146px`) and keeps it current as the
// element resizes. Fixed-position siblings use it instead of a hard-coded
// px offset, so they stay below the element when its content wraps onto
// more lines (iPad widths). The property is removed on unmount so other
// pages fall back to the default in their `var(--x, <default>)`.
const useHeightCssVar = (ref, name) => {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;

    const root = document.documentElement;
    const update = () => root.style.setProperty(name, `${el.offsetHeight}px`);
    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty(name);
    };
  }, [ref, name]);
};

export default useHeightCssVar;
